import LdCustomSwiperTabs from "./ld-custom-swiper-tabs.js";

if (!customElements.get("ld-product-series")) {
  customElements.define(
    "ld-product-series",
    class LdProductSeries extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth <= 768;
        this.swipers = {};
      }

      initTabsEvent() {
        const allPanels = this.querySelectorAll(".product-series-main");
        const tabsControl = new LdCustomSwiperTabs({
          element: this.querySelector(".custom-swiper-tabs"),
        });
        tabsControl.onIndexChange((__, el) => {
          const key = el.dataset.key;
          allPanels.forEach((panel) => {
            panel.classList.toggle("active", panel.dataset.key == key);
          });
          if (this.swipers[key]) {
            this.swipers[key].update();
            this.swipers[key].slideTo(0, 0, false);
            this.swipers[key].autoplay.start();
          }
        });
      }

      initAllSwipers() {
        const allSwipers = this.querySelectorAll(".product-series-main");
        allSwipers.forEach((wrapper) => {
          const key = wrapper.dataset.key;
          const swiperEl = wrapper.querySelector(".swiper");
          const slidesSize = wrapper.querySelectorAll(".swiper-slide").length;
          if (!this.isMobile && slidesSize <= 6) {
            return;
          }
          const swiper_options = this.isMobile
            ? {
                slidesPerView: 1.1,
                centeredSlides: true,
              }
            : {
                slidesPerView: 3,
                slidesPerColumn: 2,
                slidesPerColumnFill: "column",
              };
          const _swiper = new Swiper(swiperEl, {
            ...swiper_options,
            threshold: 30,
            spaceBetween: this.isMobile ? 16 : 0,
            // simulateTouch: this.isMobile,
            disableOnInteraction: false,
            // loop: true,
            autoplay: {
              delay: 5000,
            },
            pagination: {
              el: wrapper.querySelector(".swiper-pagination"),
              clickable: true,
            },
            navigation: {
              nextEl: wrapper.querySelector(".swiper-btn-next"),
              prevEl: wrapper.querySelector(".swiper-btn-prev"),
            },
          });
          this.swipers[key] = _swiper;
        });
      }

      connectedCallback() {
        this.initTabsEvent();
        this.initAllSwipers();
      }
    }
  );
}
